import React, { useEffect, useRef, useState } from 'react';
import ReactApexChart from "react-apexcharts";
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CLabel from '../../../../../Common/CLabel';
import PropTypes from 'prop-types';
import './radial.css'
import i18next from 'i18next';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';
import { TooltipHost } from '@fluentui/react';
import NoDataLayer from '../../../../../Common/NoDataLayer';
import { useSelector } from 'react-redux';

function SG3KPI_RADIAL(props) {
  	const { t } = useTranslation();

  	const { _boardVariableDataserieValues: boardVariableDataserieValues } = useSelector((state) => state.boardViewScope);


	const { 
		inputParam_HideHeader = false,
		inputParam_ComponentContent = null,
		inputParam_ReportHeaderMode = false,
		inputParam_BoardStructure = null,
        inputParam_Container = null
	} = props;

	const colorGet = (color) => {
		switch (color) {
			case 'v':
				return '#1f7be8d9'
				break;
			case 'a':
				return '#1f7be8d9'
				break;
			case 'r':
				return '#1f7be8d9'
				break;
			default:
				return '#1f7be8d9'
				break;
		}
	}

	const xValueMin = inputParam_ComponentContent.items !== null && inputParam_ComponentContent.items.length > 0 ? inputParam_ComponentContent.items[0].minkpi : 0;
	const xValueMax = inputParam_ComponentContent.items !== null && inputParam_ComponentContent.items.length > 0 ? inputParam_ComponentContent.items[0].maxkpi : 0;

	const [options, setOptions] = useState({
		plotOptions: {
			bar: {
				barHeight: '100%',
				distributed: true,
				horizontal: true,
				dataLabels: {
					position: 'bottom'
				},
			}
		},
		legend: {
			show: false,
		},
		colors: inputParam_ComponentContent.items[0].l_dataseries.flatMap(x => x.l_vals).filter(x => x.color !== 'na').map(item => {return colorGet(item.color)}),
		dataLabels: {
			enabled: true,
			textAnchor: 'start',
			style: {
				colors: ['#fff']
			},
			formatter: function (val, opt) {
				return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val + "%"
			},
			offsetX: 0,
			dropShadow: {
				enabled: true
			},
		},
		stroke: {
			width: 1,
			colors: ['#fff']
		},
		xaxis: {
			categories: inputParam_ComponentContent.items[0].l_dataseries.map(({ variableName }) => variableName),
		},
		yaxis: {
			labels: {
				show: false
			}
		},
		annotations: {
			xaxis: [
				{
					x: xValueMin,
					borderColor: "#d93b3b",
					borderWidth: 2,
					strokeDashArray: 0,
					opacity: 1,
					label: {
						borderColor: "#d93b3b",
						style: {
							color: "#fff",
							background: "#d93b3b",
						},
					},
				},{
					x: xValueMax,
					borderColor: "#25aa34",
					borderWidth: 2,
					strokeDashArray: 0,
					opacity: 1,
					label: {
						borderColor: "#25aa34",
						style: {
							color: "#fff",
							background: "#25aa34",
						},
					},
				},
			],
		},
		tooltip: {
			theme: 'dark',
			x: {
				show: false
			},
			y: {
				title: {
					formatter: function (value) {
						return value + "%";
					}
				}
			}
		}
	});
  
	const [series, setSeries] = useState([{data: inputParam_ComponentContent.items[0].l_dataseries.map(item => {return item.l_vals.length === 0 ? 0 : parseFloat(item.l_vals[0].valueGoalPercent)
	.toLocaleString(i18next.language, {
		style: 'decimal',
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
	}) + "%"}).filter(x => x !== 'NaN')}]);
  
	const title = boardVariableDataserieValues !== null && inputParam_ComponentContent.items !== null && inputParam_ComponentContent.items.l_dataserie > 0 ? (boardVariableDataserieValues.find(
		x => x.dataserieId === (inputParam_ComponentContent.items[0].dataSerieId !== undefined ? inputParam_ComponentContent.items[0].dataSerieId : (inputParam_ComponentContent.items[0].l_dataserie[0].dataSerieId)).variableName
	)) : '';
	const subtitle = boardVariableDataserieValues !== null && inputParam_ComponentContent.items !== null && inputParam_ComponentContent.items.l_dataserie > 0 ? (boardVariableDataserieValues.find(x => x.dataserieId === (inputParam_ComponentContent.items[0].dataSerieId !== undefined ? inputParam_ComponentContent.items[0].dataSerieId : (inputParam_ComponentContent.items[0].l_dataserie[0].dataSerieId)).um)) : '';

	return  <Card className='board-element-form h-100'>
				{
					!inputParam_HideHeader &&
					<>
						{
							inputParam_ReportHeaderMode ?
							<Card.Body className='p-0 m-0 text-start rounded-top' style={{fontSize: "13px", fontWeight: "bolder", backgroundColor: "#e3e6f3", color: "darkblue"}}>
								<TooltipHost content={inputParam_ComponentContent !== null && inputParam_ComponentContent.boardComponentTitle !== null ? inputParam_ComponentContent.boardComponentTitle : t('data-lang-lbl-chart')}>
									<div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
										{ inputParam_ComponentContent !== null && inputParam_ComponentContent.boardComponentTitle !== null ? inputParam_ComponentContent.boardComponentTitle : t('data-lang-lbl-chart')}
									</div>
								</TooltipHost>
							</Card.Body> :
							<Card.Header className="card-header-compact">
								<Card.Title className="d-flex justify-content-between">
									<b>{ inputParam_ComponentContent !== null && inputParam_ComponentContent.boardComponentTitle !== null ? inputParam_ComponentContent.boardComponentTitle : t('data-lang-lbl-chart')}</b>
									<div className='toolbar d-flex'>
										<HEADER_TOOLBAR
											inputParam_BoardStructure={inputParam_BoardStructure}
											inputParam_Container={inputParam_Container}
										/>
									</div>
								</Card.Title>
							</Card.Header>
						}
					</>
				}
				<Card.Body className='h-100 px-2 pt-2'>
				{
						inputParam_ComponentContent ?
						<div className='px-3 h-100 d-flex'>
							<Col>
								<ReactApexChart
									options={options}
									series={series}
									type="bar"
									height={300}
								/>
							</Col>
						</div>
						: <NoDataLayer display={ true } />
					}
				</Card.Body>
			</Card>
}

export default SG3KPI_RADIAL;